import { useCart } from "../context/CartContext";
import { useNavigate } from "react-router-dom";
export default function CartDrawer() {
  const {
    cartItems,
    isCartOpen,
    closeCart,
    removeFromCart,
    updateQuantity,
    cartCount,
    setIsCartOpen,
    subtotal,
  } = useCart();

  const navigate=useNavigate()
  return (
    <>
      {isCartOpen && (
        <div className="fixed inset-0 bg-black/40 z-40" onClick={closeCart} />
      )}

      <div
        className={`fixed top-0 right-0 h-full w-full max-w-[416px] bg-white z-50 flex flex-col transition-transform duration-300 ease-in-out ${
          isCartOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200">
          <h2 className="text-gray-800 font-semibold text-lg">
            Review Your Cart ({cartCount})
          </h2>
          <button onClick={closeCart} className="text-gray-500 hover:text-gray-800">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-5 py-4">
          {cartItems.length === 0 ? (
            <p className="text-gray-500 text-sm text-center mt-10">
              Your cart is empty
            </p>
          ) : (
            <div className="flex flex-col gap-6">
              {cartItems.map((item) => (
                <div key={item.id} className="relative flex gap-4">
                  <button
                    onClick={() => removeFromCart(item.id)}
                    className="absolute -top-2 -left-2 w-5 h-5 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 hover:bg-gray-300"
                  >
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                    </svg>
                  </button>

                  <div className="w-16 h-16 bg-gray-100 rounded-md flex items-center justify-center flex-shrink-0">
                    {item.image ? (
                      <img
                        src={item.image}
                        alt={item.name}
                        className="w-full h-full object-cover rounded-md"
                      />
                    ) : (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="text-gray-300" xmlns="http://www.w3.org/2000/svg">
                        <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.5" />
                        <circle cx="9" cy="9" r="1.5" fill="currentColor" />
                        <path d="M21 15l-5-5-9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    )}
                  </div>

                  <div className="flex-1">
                    <div className="flex items-start justify-between">
                      <h3 className="text-gray-800 font-medium text-sm">{item.name}</h3>
                      <span className="text-gray-800 font-medium text-sm">
                        ${(item.price * item.quantity).toFixed(2)}
                      </span>
                    </div>

                    <div className="flex items-center border border-gray-300 rounded-full mt-2 w-fit">
                      <button
                        onClick={() => updateQuantity(item.id, -1)}
                        className="w-7 h-7 flex items-center justify-center text-gray-600 hover:text-teal-600"
                      >
                        −
                      </button>
                      <span className="w-7 text-center text-sm text-gray-800">
                        {item.quantity}
                      </span>
                      <button
                        onClick={() => updateQuantity(item.id, 1)}
                        className="w-7 h-7 flex items-center justify-center text-gray-600 hover:text-teal-600"
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="border-t border-gray-200">
      

          <div className="px-5 py-4">
            <div className="flex items-center justify-between">
              <span className="text-gray-800 font-semibold text-sm">Subtotal</span>
              <span className="text-gray-800 font-semibold text-sm">${subtotal.toFixed(2)}</span>
            </div>
            <p className="text-teal-600 text-xs mt-1">
              Shipping & taxes may be re-calculated at checkout
            </p>

            <button
              disabled={cartItems.length === 0}
              onClick={()=>{
                navigate('/checkout')
                setIsCartOpen(false)
              }}
              className={`w-full flex items-center justify-center gap-2 font-semibold rounded-full py-3 mt-4 transition-colors ${
                cartItems.length === 0
                  ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                  : "bg-teal-500 hover:bg-teal-600 text-white"
              }`}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 6h15l-1.5 9h-12L6 6zM6 6L5 3H2M9 21a1 1 0 100-2 1 1 0 000 2zM18 21a1 1 0 100-2 1 1 0 000 2z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              Checkout
            </button>
          </div>
        </div>
      </div>
    </>
  );
}